import {styled, Modal} from '../../../ui-library';


export const ModalBox = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
